import { useState, useEffect } from "react";
import { Box, Grid, GridItem, VStack, Button, Text } from "@chakra-ui/react";
import DynamicFormContainer from "components/CommonForm/DynamicFormContainer";
import ProfileCard from "components/CommonForm/ProfileCard";

const formConfig = [
  {
    id: "driverInfo",
    title: "Πληροφορίες Οδηγού",
    fields: [
      { name: "driverName", label: "Όνομα Οδηγού", type: "text", required: true, gridSize: 6 },
      { name: "email", label: "Email", type: "email", required: true, gridSize: 6 },
      { name: "phoneNumber", label: "Αριθμός Τηλεφώνου", type: "text", required: true, gridSize: 6 },
      { name: "assignedClients", label: "Ανατεθειμένοι Πελάτες", type: "number", required: false, gridSize: 6 },
    ],
  },
];

const AddDriver = ({ driverData }) => {
  const [formData, setFormData] = useState({
    driverName: driverData?.driverName || "",
    email: driverData?.email || "",
    phoneNumber: driverData?.phoneNumber || "",
    assignedClients: driverData?.assignedClients || 0,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (driverData) {
      setFormData((prevData) => ({
        ...prevData,
        driverName: driverData.driverName || prevData.driverName,
        email: driverData.email || prevData.email,
        phoneNumber: driverData.phoneNumber || prevData.phoneNumber,
        assignedClients: driverData.assignedClients || prevData.assignedClients,
      }));
    }
  }, [driverData]);

  const validateForm = () => {
    let newErrors = {};
    formConfig[0].fields.forEach((field) => {
      if (field.required && !formData[field.name]) {
        newErrors[field.name] = "Αυτό το πεδίο είναι υποχρεωτικό";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      console.log("Τελικό Payload:", JSON.stringify(formData, null, 2));
    }
  };

  return (
    <Box  mt={24}>
      <ProfileCard name={formData.driverName || "Όνομα Οδηγού"} profileImage="" />
      <Grid mt={4} templateColumns="1fr" gap={6} alignItems="start">
        <GridItem>
          <VStack spacing={6} align="stretch">
            <DynamicFormContainer
              key={formConfig[0].id}
              title={formConfig[0].title}
              cardData={formConfig[0]}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
            />
          </VStack>
        </GridItem>
      </Grid>

      {Object.keys(errors).length > 0 && (
        <Text color="red.500" mt={4}>
          Παρακαλώ διορθώστε τα σφάλματα πριν την υποβολή.
        </Text>
      )}

      <Button mt={6} colorScheme="blue"   bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                w="125px"
                h="35px"
                color="#fff"
                fontSize="xs"
                fontWeight="bold"
                alignSelf={{ sm: "flex-start", lg: null }}
                mb={{ sm: "12px", md: "0px" }}onClick={handleSubmit}>
        Υποβολή
      </Button>
    </Box>
  );
};

export default AddDriver;
